import { Pipe, PipeTransform } from '@angular/core'

import { EM_DASH } from '../../../constants/constant.content'
import {
  NUMBER_ONE,
  NUMBER_TEN,
  NUMBER_THREE,
  NUMBER_TWO,
} from '../../../constants/constant.numbers'

@Pipe({
  name: 'expenseRatioValue',
})
export class ExpenseRatioValuePipe implements PipeTransform {
  // eslint-disable-next-line complexity,max-statements
  transform(valueToBeTrimmedArg: any) {
    if (valueToBeTrimmedArg === undefined || valueToBeTrimmedArg === null) {
      return EM_DASH
    } else if (valueToBeTrimmedArg.toString().trim() === '') {
      return EM_DASH
    } else if (isNaN(valueToBeTrimmedArg)) {
      return valueToBeTrimmedArg
    } else {
      const valueToBeTrimmedNum = Number(valueToBeTrimmedArg)
      const expenseRatioValue: any = valueToBeTrimmedNum
        .toFixed(NUMBER_THREE)
        .split('.')
      if (expenseRatioValue[NUMBER_ONE] % NUMBER_TEN === 0) {
        return valueToBeTrimmedNum.toFixed(NUMBER_TWO) + '%'
      } else {
        return valueToBeTrimmedNum.toFixed(NUMBER_THREE) + '%'
      }
    }
  }
}
